module.exports = __webpack_public_path__ + "static/media/googleplay.e3189417.png";